// extracted by mini-css-extract-plugin
module.exports = {"SideNavbar":"sidebar_SideNavbar__1GdVb","Fixed":"sidebar_Fixed__b-s92","changeWidth":"sidebar_changeWidth__ySxHp","ActiveChange":"sidebar_ActiveChange__3Tujk"};